module.exports = __webpack_public_path__ + "img/import-excel.9d6247d7.svg";